export default "__VITE_ASSET__e98494b1__"